<nav class="admin-nav">
    @if (isAdmin) {
        <a routerLink="/gateways" routerLinkActive="active">Admin gateways</a>
        <a routerLink="/users" routerLinkActive="active">Users</a>
        <a routerLink="/files" routerLinkActive="active">Files</a>
        <a routerLink="/categories" routerLinkActive="active">Categories</a>
    } @else if (isLocal) {
        <!-- Local (file-portal) user: Files, never Gateways — matches the legacy
             usr/main.php menu. -->
        <a routerLink="/my-files" routerLinkActive="active">Files</a>
    } @else {
        <!-- Cloud gateway customer: Gateways, never Files — matches the legacy
             usr/main_gw.php menu. -->
        <a routerLink="/gateways" routerLinkActive="active">Gateways</a>
    }
    <a routerLink="/account" routerLinkActive="active">Account Details</a>
</nav>
